import script from "./MigrationMap.vue?vue&type=script&setup=true&lang=js"
export * from "./MigrationMap.vue?vue&type=script&setup=true&lang=js"

import "./MigrationMap.vue?vue&type=style&index=0&id=4df435c9&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df435c9"]])

export default __exports__